import { RulesetApplicability } from "types/DefaultRules/DefaultRules";

/**
 * Shared body renderer for the provider/payer columns in ruleset tables (CLE-2524).
 *
 * SCOPED rows render the plain provider/payer name. Non-scoped rows render a styled
 * label so their reach is unmistakable:
 *   - TYPICAL:  "Typical" — an inert template; never applied by pricing.
 *   - FALLBACK: the honest scope value the caller supplies ("All providers" /
 *     "All payers") — a live rule that floors every contract without a more
 *     specific rule.
 */
export function defaultScopeCell(
  row: { applicability?: RulesetApplicability; isDefault?: boolean },
  value?: string
) {
  const applicability =
    row.applicability ?? (row.isDefault ? "TYPICAL" : "SCOPED");
  if (applicability === "SCOPED") return value ?? "";
  return (
    <span
      style={{
        color: "#6b7280",
        fontStyle: "italic",
        fontWeight: 600,
      }}
    >
      {applicability === "TYPICAL" ? "Typical" : value || "All"}
    </span>
  );
}
